import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TemplateManagerService implements OnDestroy{
  private url = 'api/templateManager';
  private headers = new HttpHeaders({ "Content-Type": "application/json" });
  options = { headers: this.headers };
  regex = /\[(.*?)\]/g;
  storeTemplateVar:any[]=[];
  private destroy$ = new Subject<void>();

  constructor( private http: HttpClient,) { }

  getTemplate(templateId){
    return this.http.get(`/${this.url}/getTemplate?TemplateId=${templateId}`, this.options);
  }

  getTemplateVariables(){
    return this.http.get(`/${this.url}/getTemplateVariables`, this.options);
  }

  updateTemplate(payload){
    return this.http.put(`/${this.url}/updateTemplate`,payload, this.options);
  }

  getTemplates(){
    return this.http.get(`/${this.url}/getTemplates`, this.options);
  }

  addTemplate(payload){
    return this.http.post(`/${this.url}/addTemplate`,payload, this.options);
  }

  deleteTemplate(templateId){
    return this.http.put(`/${this.url}/deleteTemplate?TemplateId=${templateId}`, this.options);
  }

  formatVarNameWithColumnName(text){
    const str =text.match(this.regex)
    if(str){
      str.forEach((el:string)=>{
       const index= this.storeTemplateVar.findIndex(variable => variable.name == el.substring(1, el.length - 1))
       if(index != -1){
        text = text.replaceAll(el,'$$$'+this.storeTemplateVar[index].columnName+'$$$')
       } 
      })
    }
    return text;
  }

  setPosition(textArea,start,item){
    textArea.focus();
    let index = start ? start : textArea.selectionStart;
    const position= index +item.name.length + 3;
    textArea.setSelectionRange(position, position);
  }

  formatTempWithVarName(templateText){
    templateText = templateText.replace(/\$\$(.*?)\$\$/g, (match, group1) => `[${group1}]`)
    const str = templateText.match(this.regex);
    if(str){
      str.forEach((el:string)=>{
       const index= this.storeTemplateVar.findIndex(variable => variable.columnName == el.substring(1, el.length - 1))
       if(index != -1){
        templateText = templateText.replaceAll(el,'['+this.storeTemplateVar[index].name+']')
       } 
      })
    }
    return templateText;
  }

  formatVarNameWithValues(selectedRow,templateText){
    selectedRow = this.setWarehouseDetail(selectedRow);
    const str =templateText.match(this.regex)
    if(str){
      str.forEach((el:string)=>{
       const index= this.storeTemplateVar.findIndex(variable => variable.name == el.substring(1, el.length - 1))
       if(index != -1){
        const colName=selectedRow[this.storeTemplateVar[index].columnName.charAt(0).toLowerCase() + this.storeTemplateVar[index].columnName.slice(1)]        
        templateText = templateText.replaceAll(el,`<span class="selectedCaseTemplate mb-1 py-0 px-1">${colName}</span>`);
       } 
      })
    }
    templateText = templateText.replace(/\n/g, '<br>');
    return templateText;
  }

  setWarehouseDetail(selectedRow){
    selectedRow['destinationWarehouse.Code'] = selectedRow.destinationWarehouse.code;
    selectedRow['destinationWarehouse.AddressLine1'] = selectedRow.destinationWarehouse.addressLine1;
    selectedRow['destinationWarehouse.City'] = selectedRow.destinationWarehouse.city;
    selectedRow['destinationWarehouse.CountryCode'] = selectedRow.destinationWarehouse.countryCode;
    selectedRow['destinationWarehouse.State'] = selectedRow.destinationWarehouse.state;
    selectedRow['destinationWarehouse.Postal'] = selectedRow.destinationWarehouse.postal;
    return selectedRow;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
